// extracted by mini-css-extract-plugin
export default {"component":"BonusTitle__component--slots-s2HR4"};